// @ts-nocheck

import * as Types from '../../../../../graphql/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import { gql } from '@apollo/client';
export type GetFieldMetadataForPathsQueryVariables = Types.Exact<{
  pathUrns?: Types.InputMaybe<
    Array<Types.InputMaybe<Types.Scalars['String']['input']>> | Types.InputMaybe<Types.Scalars['String']['input']>
  >;
}>;

export type GetFieldMetadataForPathsQuery = {
  fieldMetadataForPaths: { definitions?: Array<CommonFieldDefinitionDataFragment | null> | null };
};

export type CommonFieldDefinitionDataFragment = {
  __typename: 'CommonFieldDefinitionModel';
  urn?: string | null;
  type?: Types.CommonFieldTypeModel | null;
  enabled: boolean;
  required: boolean;
  multivalued: boolean;
  regex?: string | null;
  message?: string | null;
  values?: Array<{ label?: string | null; value?: string | null } | null> | null;
  rules?: Array<{
    enabled?: boolean | null;
    regex?: string | null;
    message?: string | null;
    required?: boolean | null;
    condition?: {
      operator?: Types.FieldMetadataOperator | null;
      field?: string | null;
      values?: Array<string | null> | null;
    } | null;
    values?: Array<{ label?: string | null; value?: string | null } | null> | null;
  } | null> | null;
};

export const CommonFieldDefinitionDataFragmentDoc = gql`
    fragment CommonFieldDefinitionData on CommonFieldDefinitionModel {
  __typename
  urn
  type
  enabled
  required
  multivalued
  values {
    label
    value
  }
  regex
  message
  rules {
    condition {
      operator
      field
      values
    }
    enabled
    values {
      label
      value
    }
    regex
    message
    required
  }
}
    ` as unknown as DocumentNode<CommonFieldDefinitionDataFragment, unknown>;
export const GetFieldMetadataForPathsDocument = gql`
    query GetFieldMetadataForPaths($pathUrns: [String]) {
  fieldMetadataForPaths(pathUrns: $pathUrns) {
    definitions {
      ...CommonFieldDefinitionData
    }
  }
}
    ${CommonFieldDefinitionDataFragmentDoc}` as unknown as DocumentNode<
  GetFieldMetadataForPathsQuery,
  GetFieldMetadataForPathsQueryVariables
>;
